module.exports = __webpack_public_path__ + "img/pro-p-slider22.14386387.jpg";